import { render, staticRenderFns } from "./PhysicalSpacesForm.vue?vue&type=template&id=6622bb33&"
import script from "./PhysicalSpacesForm.vue?vue&type=script&lang=js&"
export * from "./PhysicalSpacesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports